import { RootHeader } from "@/components/RootHeader";
import { Button, Toast } from "antd-mobile";
import { useState } from "react";
import { Icon } from "@/components/Icon";
import { Detail } from "./Detail";
import './index.scss';
import { useCryptoPayments } from "../../../stores/CryptoTradingStore";
import { useGlobalVerify } from "@/logic/verify";
import { applyBusiness } from "@/apis/crypto";
import { useUserInfoStore } from "@/stores/userInfo";
import styles from '../index.module.scss';
import { ContentTabs } from "../components/ContentTabs";
import { useNavigate } from "react-router-dom";
import { cn } from "@/libs";
const title = 'VipPay';
const steps = [{
  title: '一、开通成为商家',
  text: '缴纳保证金可获取高额收益'
}, {
  title: '二、充值数字货币',
  text: ''
}, {
  title: '三、转入商家余额',
  text: ''
}, {
  title: '四、变现拿高额补贴',
  text: '',
  bg: 'red'
}];
export const PageCryptoEarnAgree = () => {
  const [checked, setChecked] = useState<boolean>(false);
  const [verifySecurePassword] = useGlobalVerify();
  const [setUserInfo] = useUserInfoStore()(state => [state.setUserInfo]);
  const navidate = useNavigate();
  const store = useCryptoPayments();
  const fetchToapplyBusiness = async () => {
    const securePassword = await verifySecurePassword();
    if (!securePassword) return;
    // 验证用户是否同意用户协议
    if (!checked) {
      Toast.show("请先同意用户协议");
      return;
    }
    const {
      ok,
      msg
    } = await applyBusiness({
      securePassword: (securePassword as string)
    });
    if (ok) {
      Toast.show("申请成功");
      setUserInfo({
        BusinessStatus: 1
      });
      navidate('/root/crypto_earn', {
        replace: true
      });
    } else {
      Toast.show(msg);
    }
  };
  return <div className={cn(styles.pageTrade, 'earn_page')} data-sentry-component="PageCryptoEarnAgree" data-sentry-source-file="index.tsx">
      <RootHeader title={'赚钱'} data-sentry-element="RootHeader" data-sentry-source-file="index.tsx" />
      <ContentTabs active="crypto_earn_agree" data-sentry-element="ContentTabs" data-sentry-source-file="index.tsx" />
      <div className="earn_page_title">{title}平台全程担保 <Icon name={'platform-sure'} data-sentry-element="Icon" data-sentry-source-file="index.tsx" /></div>
      <div className="earn_page_title2">
        简单三步做商家，享受
        <span>高额补贴</span> ，轻松赚大钱
      </div>
      <div className="earn_page_block">
        <div className="earn_page_title">赚钱流程：</div>
        <div className="earn_page_content">
          <div className="earn_page_steps">
          {steps.map(step => {
            return <div key={step.title} className={`earn_page_step`}>
                <div className={`earn_page_step_content ${step.bg || 'green'}`}>
                  <div className={'earn_page_step_title'}>{step.title}</div>
                  <div className={'earn_page_step_text'}>{step.text}</div>
                </div>
              </div>;
          })}
          </div>            
        </div>
        <Detail title={title} hideAlipayWechatAtMerchantPage={store.hideAlipayWechatAtMerchantPage} data-sentry-element="Detail" data-sentry-source-file="index.tsx" />
        <div className="earn_page_agreement">
          <div onClick={() => setChecked(!checked)}>
            <Icon name={checked ? 'checked' : 'unchecked'} size={'0.16rem'} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
          </div>
          
          <div className="earn_page_agreement_text">
            我已阅读
            <span className="earn_page_agreement_rule">《赚钱规则》</span>，自愿成为
            {title}钱包商家，并自行判断和承担风险。
          </div>
        </div>
        <Button className={"common-submit-button"} onClick={() => fetchToapplyBusiness()} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          确定成为商家
        </Button>
      </div>
      </div>;
};